import TextArea from "./Textarea";
import StyledTextArea from "./StyledTextarea";

export { TextArea, StyledTextArea };

export default TextArea;
